// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.is-partner .v-input.v-input--is-dirty .v-input--switch__track {\n    background-color: #cdf3ff !important;\n    border-color: #cdf3ff !important;\n}\n", ""]);
// Exports
module.exports = exports;
